import { render, staticRenderFns } from "./CreateEventNavigation.vue?vue&type=template&id=1b4cd4eb"
import script from "./CreateEventNavigation.vue?vue&type=script&lang=js"
export * from "./CreateEventNavigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports